import React from 'react'
import { useHistory } from 'react-router-dom'

import { FiAlertTriangle, FiArrowLeft } from 'react-icons/fi'
import usePersistedState from '../../hooks/usePersistedState'
import Header from '../../components/Header'

import { Container } from './styles'
import { ErroProps } from '../../utils/interfaces'

const Erro: React.FC = () => {
  const [erroProps] = usePersistedState<ErroProps>('erroProps', {} as ErroProps)
  const history = useHistory()

  return (
    <>
      <Header>
        <FiArrowLeft
          type="button"
          cursor="pointer"
          onClick={() => history.goBack()}
        />
      </Header>
      <Container>
        <FiAlertTriangle color="#4CA585" size={100} />
        <h2>{erroProps.title}</h2>
        {erroProps.description ? (
          <strong>{erroProps.description}</strong>
        ) : (
          <></>
        )}
      </Container>
    </>
  )
}

export default Erro
